import { TextCodes } from '@api/types/translation/TextCodes';
import { Alert } from '@mui/material';
import { t } from '@translations';

export const NoResults = () => {
  return <Alert severity='info'>{t(TextCodes.Search.NoResultsInSection)}</Alert>;
};
